import CollegeApplicationApi from "Api/CollegeApplicationApi"
import React, { useEffect, useState } from "react"
import {
  Col,
  Pagination,
  PaginationItem,
  PaginationLink,
  Row,
  Table,
} from "reactstrap"
import CustomBreadCrumb from "utils/CustomBreadCrumb/CustomBreadCrumb"
import DataTableLoader from "SkeletonLoader/DataTableLoader"
import "./CollegeApplicationList.scss"

const CollegeApplicationList = () => {
  const [applications, setApplications] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(1)
  const [totalItems, setTotalItems] = useState(0)
  const [limit] = useState(10)

  const breadcrumbItems = [
    { label: "Pixwik", link: "#" },
    { label: "Applications", link: "#" },
    { label: "College Applications", link: "#" },
  ]

  const fetchApplications = async () => {
    setLoading(true)
    const queryParams = {
      page: currentPage,
      limit: limit,
    }
    CollegeApplicationApi.getCollegeApplications(queryParams)
      .then(response => {
        setApplications(response.data.data)
        setTotalPages(response.data.pagination.totalPages)
        setTotalItems(response.data.pagination.total)
        setLoading(false)
      })
      .catch(error => {
        setError(error)
        setLoading(false)
      })
  }

  useEffect(() => {
    fetchApplications()
  }, [currentPage])

  return (
    <div className="college-application-list">
      <Row>
        <Col xs="12">
          <div className="list-header d-flex align-items-center justify-content-between">
            <CustomBreadCrumb data={breadcrumbItems} pageTitle="College Applications" />
          </div>

          <div className="data-table table-responsive mt-4 mb-3">
            {loading ? (
              <DataTableLoader cols={7} />
            ) : (
              <Table className="table mb-0">
                <thead className="table-light">
                  <tr>
                    <th>#</th>
                    <th>Institution Name</th>
                    <th>Program</th>
                    <th>Course</th>
                    <th>Full Name</th>
                    <th>Age</th>
                    <th>Email</th>
                    <th>Phone</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(applications) && applications.map((application, index) => (
                    <tr key={application._id}>
                      <th scope="row">{(currentPage - 1) * limit + index + 1}</th>
                      <td>{application.institutionName}</td>
                      <td>{application.programName}</td>
                      <td>{application.courseName}</td>
                      <td>{application.fullName}</td>
                      <td>{application.age}</td>
                      <td>{application.email}</td>
                      <td>{application.phone}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </div>

          {totalPages > 1 && (
            <div className="pagination-container d-flex align-items-center justify-content-end">
              <Pagination>
                <PaginationItem disabled={currentPage <= 1}>
                  <PaginationLink previous onClick={() => setCurrentPage(currentPage - 1)} />
                </PaginationItem>
                {[...Array(Math.min(3, totalPages))].map((_, index) => (
                  <PaginationItem key={index} active={index + 1 === currentPage}>
                    <PaginationLink onClick={() => setCurrentPage(index + 1)}>
                      {index + 1}
                    </PaginationLink>
                  </PaginationItem>
                ))}
                {totalPages > 3 && <PaginationItem disabled>
                  <PaginationLink>...</PaginationLink>
                </PaginationItem>}
                <PaginationItem disabled={currentPage >= totalPages}>
                  <PaginationLink next onClick={() => setCurrentPage(currentPage + 1)} />
                </PaginationItem>
              </Pagination>
            </div>
          )}
        </Col>
      </Row>
    </div>
  )
}

export default CollegeApplicationList
